import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useEffect, useState } from "react";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (internalNote: string) => void | Promise<void>;
};

export function TransferApproveDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) setNote("");
  }, [open]);

  const handleClose = () => {
    if (loading) return;
    setNote("");
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && handleClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ອະນຸມັດຄຳຂໍເບິກ</DialogTitle>
          <DialogDescription>
            {requestNo} — ກວດຈຳນວນອະນຸມັດໃນຕາຕະລາງແລ້ວ ຈຶ່ງຢືນຢັນດ້ວຍໝາຍເຫດ (ຖ້າມີ).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="approve-note">ເຫດຜົນ / ໝາຍເຫດພາຍໃນສູນກາງ (HQ)</Label>
          <Textarea
            id="approve-note"
            placeholder="ຕົວຢ່າງ: ອະນຸມັດຄົບຕາມຄຳຂໍ · ຫຼຸດບາງລາຍການຕາມສະຕ໋ອກ Hub"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="min-h-[100px]"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            ຍົກເລີກ
          </Button>
          <Button
            onClick={() => void onConfirm(note.trim())}
            isLoading={loading}
          >
            ຢືນຢັນອະນຸມັດ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
